<template>
  <div>
    <div>
      <div class="max-w-5xl mx-auto">
        <div v-if="action == 'create'">
          <h3 class="text-lg font-medium leading-6 text-gray-900">
            Crea menu
          </h3>
          <p class="mt-1 text-sm leading-5 text-gray-600">
            Dai un nome al tuo menu, pianifica la visibilità per i tuoi clienti
            ed infine componilo selezionando i piatti.
          </p>
        </div>
        <template v-if="action == 'update'">
          <div
            class="flex flex-wrap items-center justify-between -mt-4 -ml-4 sm:flex-no-wrap"
          >
            <div class="mt-4 ml-4">
              <h3 class="text-lg font-medium leading-6 text-gray-900">
                {{ form.name }}
              </h3>
            </div>
            <div class="flex-shrink-0 mt-4 ml-4">
              <span class="inline-flex mr-2 rounded-md shadow-sm">
                <router-link
                  :to="{ name: 'MenuCompose', params: { id: id, idmenu } }"
                  class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-white bg-green-400 border rounded-md shadow-sm border-gray-50 hover:text-gray-50 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5 hover:bg-green-500 focus:border-green-400 focus:shadow-outline-green"
                >
                  Piatti del menu
                </router-link>
              </span>

              <span class="inline-flex rounded-md shadow-sm">
                <button
                  @click="deleteModal"
                  type="button"
                  class="inline-flex items-center px-4 py-2 text-sm font-medium leading-5 text-red-700 transition duration-150 ease-in-out bg-white border border-transparent border-red-700 rounded-md hover:bg-red-200 focus:outline-none focus:border-indigo-300 focus:shadow-outline-indigo active:bg-indigo-200"
                >
                  Elimina Menu
                </button>
              </span>
            </div>
          </div>
        </template>
      </div>

      <div class="max-w-5xl mx-auto mt-5">
        <form v-on:submit.prevent="onSubmit">
          <div class="">
            <div class="px-4 py-5 bg-white rounded-t-lg shadow sm:p-6">
              <div class="grid grid-cols-6 gap-6">
                <div class="col-span-6">
                  <label
                    for="name"
                    class="block text-sm font-medium leading-5 text-gray-700"
                    >Nome</label
                  >
                  <div
                    v-for="(language, index) in form.checked_languages"
                    :key="'name' + language.code"
                  >
                    <div
                      class="flex mt-1 rounded-md shadow-sm"
                      :class="index > 0 ? 'mt-3' : ''"
                    >
                      <span
                        class="inline-flex items-center justify-center w-10 px-2 text-center text-gray-500 border border-r-0 border-gray-300 rounded-l-md bg-gray-50 sm:text-sm"
                      >
                        {{ language.code }}
                      </span>

                      <input
                        :class="
                          tl.nameTranslationErrors[language.code]
                            ? 'border-red-300'
                            : ''
                        "
                        v-model="tl.nameTranslation[language.code]"
                        :id="'language_' + language.id"
                        :name="'language_' + language.id"
                        class="flex-1 block w-full px-3 py-2 rounded-none form-input rounded-r-md sm:text-sm sm:leading-5"
                      />
                      <button
                        @click="copyText(tl.nameTranslation[language.code])"
                        v-if="form.checked_languages.length > 1 && index === 0"
                        type="button"
                        class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out border border-gray-300 rounded-r-md bg-gray-50 hover:text-gray-500 hover:bg-white focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700"
                      >
                        <svg
                          class="w-5 h-5 text-gray-400 transform rotate-180"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            d="M3 3a1 1 0 000 2h11a1 1 0 100-2H3zM3 7a1 1 0 000 2h5a1 1 0 000-2H3zM3 11a1 1 0 100 2h4a1 1 0 100-2H3zM13 16a1 1 0 102 0v-5.586l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 101.414 1.414L13 10.414V16z"
                          ></path>
                        </svg>
                        <span class="ml-2 ">Copia </span>
                      </button>
                    </div>
                    <p
                      class="mt-1 text-xs text-red-600"
                      v-if="tl.nameTranslationErrors[language.code]"
                    >
                      {{ tl.nameTranslationErrors[language.code] }}
                    </p>
                  </div>
                </div>

                <div class="col-span-6">
                  <label
                    for="name"
                    class="block text-sm font-medium leading-5 text-gray-700"
                    >Descrizione</label
                  >
                  <div
                    v-for="(language, index) in form.checked_languages"
                    :key="'description' + language.code"
                  >
                    <div
                      class="flex mt-1 rounded-md shadow-sm"
                      :class="index > 0 ? 'mt-3' : ''"
                    >
                      <span
                        class="inline-flex items-center justify-center w-10 px-2 text-center text-gray-500 border border-r-0 border-gray-300 rounded-l-md bg-gray-50 sm:text-sm"
                      >
                        {{ language.code }}
                      </span>

                      <input
                        :class="
                          tl.descriptionTranslationErrors[language.code]
                            ? 'border-red-300'
                            : ''
                        "
                        v-model="tl.descriptionTranslation[language.code]"
                        :id="'language_' + language.id"
                        :name="'language_' + language.id"
                        class="flex-1 block w-full px-3 py-2 rounded-none form-input rounded-r-md sm:text-sm sm:leading-5"
                      />
                      <button
                        @click="
                          copyDescrText(
                            tl.descriptionTranslation[language.code]
                          )
                        "
                        v-if="form.checked_languages.length > 1 && index === 0"
                        type="button"
                        class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out border border-gray-300 rounded-r-md bg-gray-50 hover:text-gray-500 hover:bg-white focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700"
                      >
                        <svg
                          class="w-5 h-5 text-gray-400 transform rotate-180"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            d="M3 3a1 1 0 000 2h11a1 1 0 100-2H3zM3 7a1 1 0 000 2h5a1 1 0 000-2H3zM3 11a1 1 0 100 2h4a1 1 0 100-2H3zM13 16a1 1 0 102 0v-5.586l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 101.414 1.414L13 10.414V16z"
                          ></path>
                        </svg>
                        <span class="ml-2 ">Copia </span>
                      </button>
                    </div>
                    <p
                      class="mt-1 text-xs text-red-600"
                      v-if="tl.descriptionTranslationErrors[language.code]"
                    >
                      {{ tl.descriptionTranslationErrors[language.code] }}
                    </p>
                  </div>
                </div>

                <div class="col-span-6 lg:col-span-2">
                  <h3 class="text-sm font-medium leading-6 text-gray-900">
                    Ristorante
                  </h3>
                  <label
                    @click="setStandardMenu()"
                    class="relative flex p-4 mt-1 border border-gray-200 cursor-pointer rounded-tl-md rounded-tr-md"
                  >
                    <input
                      type="radio"
                      :checked="!isEnableMenuHotel"
                      name="menu_macro_type"
                      class="w-4 h-4 mt-1 text-indigo-600 transition duration-150 ease-in-out form-radio"
                    />
                    <div class="flex flex-col ml-3">
                      <!-- Checked: "text-indigo-900", Not Checked: "text-gray-900" -->
                      <span
                        id="privacy-setting-0-label"
                        class="block text-sm font-medium text-gray-900"
                      >
                        Menu standard
                      </span>
                      <!-- Checked: "text-indigo-700", Not Checked: "text-gray-500" -->
                      <!--
                      <span class="block text-sm text-gray-500">
                        Menu generico per ristoranti
                      </span>
                      -->
                    </div>
                  </label>
                </div>

                <div class="col-span-6 lg:col-span-4">
                  <h3 class="text-sm font-medium leading-6 text-gray-900">
                    Hotel
                  </h3>
                  <div class="grid grid-cols-2 mt-1">
                    <label
                      v-for="ordersetting in hotelOrdersSettings"
                      :key="ordersetting.id"
                      @click="setMenuType()"
                      class="relative flex p-4 border border-gray-200 cursor-pointer rounded-tl-md rounded-tr-md"
                    >
                      <input
                        type="radio"
                        v-model="menuTypeId"
                        name="menu_macro_type"
                        v-bind:value="ordersetting.id"
                        class="w-4 h-4 mt-1 text-indigo-600 transition duration-150 ease-in-out form-radio"
                      />
                      <div class="flex flex-col ml-3">
                        <!-- Checked: "text-indigo-900", Not Checked: "text-gray-900" -->
                        <span
                          id="privacy-setting-0-label"
                          class="block text-sm font-medium text-gray-900"
                        >
                          {{ ordersetting.name }}
                        </span>
                        <!-- Checked: "text-indigo-700", Not Checked: "text-gray-500" -->
                        <span
                          class="block text-sm text-gray-500"
                          v-if="menuTypeId == ordersetting.id"
                        >
                          <span class="text-red-700">Attenzione</span>:
                          {{ alertMenuType }}
                          <router-link
                            :to="{ name: 'OrdersSettingsHotel' }"
                            class="font-semibold text-indigo-600"
                            >Modifica</router-link
                          >
                        </span>
                      </div>
                    </label>
                    <label
                      @click="setRoomService()"
                      class="relative flex p-4 border border-gray-200 cursor-pointer rounded-tl-md rounded-tr-md"
                    >
                      <input
                        type="radio"
                        name="menu_macro_type"
                        :checked="isRoomService"
                        class="w-4 h-4 mt-1 text-indigo-600 transition duration-150 ease-in-out form-radio"
                      />
                      <div class="flex flex-col ml-3">
                        <!-- Checked: "text-indigo-900", Not Checked: "text-gray-900" -->
                        <span
                          id="privacy-setting-0-label"
                          class="block text-sm font-medium text-gray-900"
                        >
                          Servizio in camera
                        </span>
                        <!-- Checked: "text-indigo-700", Not Checked: "text-gray-500" -->
                      </div>
                    </label>
                  </div>
                </div>
                <!--
                <div class="col-span-6 lg:col-span-2"></div>
                
                isEnableMenuHotel: {{ isEnableMenuHotel }} <br />
                menuTypeId: {{ menuTypeId }} <br />
                isRoomService: {{ isRoomService }} <br />

                <div class="col-span-6 lg:col-span-2">
                  <div class="flex justify-between">
                    <h3 class="text-lg font-medium leading-6 text-gray-900">
                      Menu hotel
                    </h3>

                    <span
                      @click="toogleHotel()"
                      :class="
                        this.isEnableMenuHotel ? 'bg-indigo-600' : 'bg-gray-200'
                      "
                      role="checkbox"
                      tabindex="0"
                      aria-checked="false"
                      class="relative flex-shrink-0 inline-block h-6 mr-10 transition-colors duration-200 ease-in-out bg-gray-200 border-2 border-transparent rounded-full cursor-pointer w-11 focus:outline-none focus:shadow-outline"
                    >
                      <span
                        aria-hidden="true"
                        :class="
                          this.isEnableMenuHotel
                            ? 'translate-x-5'
                            : 'translate-x-0'
                        "
                        class="inline-block w-5 h-5 transition duration-200 ease-in-out transform translate-x-0 bg-white rounded-full shadow"
                      ></span>
                    </span>
                  </div>
                  <p class="mt-1 text-sm leading-5 text-gray-500">
                    Questa opzione, se abilitata, prevede un report dei piatti
                    da preparare
                  </p>
                </div>

                <div
                  class="col-span-6 lg:col-span-2"
                  v-show="this.isEnableMenuHotel"
                >
                  <div>
                    <legend
                      class="text-base font-medium leading-6 text-gray-900"
                    >
                      Seleziona il pasto
                    </legend>

                    <select
                      :class="formErrors.menuTypeId ? 'border-red-300' : ''"
                      v-model="menuTypeId"
                      class="block w-full mt-1 transition duration-150 ease-in-out form-select sm:text-sm sm:leading-5"
                    >
                      <option
                        v-for="ordersetting in hotelOrdersSettings"
                        v-bind:value="ordersetting.id"
                        :key="ordersetting.id"
                      >
                        {{ ordersetting.name }}
                      </option>
                    </select>
                    <p
                      class="mt-1 text-xs text-red-600"
                      v-if="formErrors['menuTypeId']"
                    >
                      {{ formErrors["menuTypeId"][0] }}
                    </p>

                    <p
                      class="mt-1 text-sm leading-5 text-gray-500"
                      v-if="menuTypeId"
                    >
                      <span class="text-red-700">Attenzione</span>:
                      {{ alertMenuType }}
                      <router-link
                        :to="{ name: 'OrdersSettingsHotel' }"
                        class="font-semibold text-indigo-600"
                        >Modifica</router-link
                      >
                    </p>
                  </div>
                </div>
-->
                <div class="col-span-6 lg:col-span-2">
                  <div
                    class="flex justify-between"
                    v-show="!this.isEnableMenuHotel || this.isRoomService"
                  >
                    <h3 class="text-lg font-medium leading-6 text-gray-900">
                      Nascondi prezzo piatti
                    </h3>

                    <span
                      @click="toogleHidePrice()"
                      :class="
                        this.isEnableHidePrice ? 'bg-indigo-600' : 'bg-gray-200'
                      "
                      role="checkbox"
                      tabindex="0"
                      aria-checked="false"
                      class="relative flex-shrink-0 inline-block h-6 mr-10 transition-colors duration-200 ease-in-out bg-gray-200 border-2 border-transparent rounded-full cursor-pointer w-11 focus:outline-none focus:shadow-outline"
                    >
                      <!-- On: "translate-x-5", Off: "translate-x-0" -->
                      <span
                        aria-hidden="true"
                        :class="
                          this.isEnableHidePrice
                            ? 'translate-x-5'
                            : 'translate-x-0'
                        "
                        class="inline-block w-5 h-5 transition duration-200 ease-in-out transform translate-x-0 bg-white rounded-full shadow"
                      ></span>
                    </span>
                  </div>
                </div>

                <div class="col-span-6"></div>

                <div class="col-span-6 lg:col-span-2">
                  <div class="flex justify-between">
                    <!--
                    <h3 class="text-lg font-medium leading-6 text-gray-900">Attivo</h3>
                    -->
                    <h3 class="text-lg font-medium leading-6 text-gray-900">
                      Visibilità
                    </h3>

                    <span
                      @click="toogle()"
                      :class="this.isEnable ? 'bg-indigo-600' : 'bg-gray-200'"
                      role="checkbox"
                      tabindex="0"
                      aria-checked="false"
                      class="relative flex-shrink-0 inline-block h-6 mr-10 transition-colors duration-200 ease-in-out bg-gray-200 border-2 border-transparent rounded-full cursor-pointer w-11 focus:outline-none focus:shadow-outline"
                    >
                      <!-- On: "translate-x-5", Off: "translate-x-0" -->
                      <span
                        aria-hidden="true"
                        :class="
                          this.isEnable ? 'translate-x-5' : 'translate-x-0'
                        "
                        class="inline-block w-5 h-5 transition duration-200 ease-in-out transform translate-x-0 bg-white rounded-full shadow"
                      ></span>
                    </span>
                  </div>
                  <p class="mt-1 text-sm leading-5 text-gray-500">
                    Attiva o disattiva il menu

                    <!--
                      Attiva o disattiva il menu e pianifica la sua visibilità
                      -->
                  </p>
                </div>
                <div class="col-span-6 lg:col-span-2">
                  <fieldset class="" v-show="this.isEnable">
                    <legend
                      class="text-base font-medium leading-6 text-gray-900"
                    >
                      <!--Pianifica la visibilità del tuo menu-->
                      A quali giorni si riferisce il menu?
                    </legend>
                    <p class="text-sm leading-5 text-gray-500">
                      Seleziona una delle opzioni
                    </p>
                    <div class="mt-4">
                      <div class="flex">
                        <input
                          id="always"
                          v-model="schedule.scheduleType"
                          :value="0"
                          name="scheduleType"
                          type="radio"
                          class="w-4 h-4 mt-1 text-indigo-600 transition duration-150 ease-in-out form-radio"
                        />
                        <label
                          for="always"
                          class="ml-3"
                          @click="setscheduleType(0)"
                        >
                          <span
                            class="block text-sm font-medium leading-5 text-gray-700"
                          >
                            <!--Ogni giorno-->
                            Tutti i giorni
                          </span>
                        </label>
                      </div>
                      <div class="mt-4 ">
                        <div class="flex">
                          <input
                            id="weekDays"
                            v-model="schedule.scheduleType"
                            :value="1"
                            name="scheduleType"
                            type="radio"
                            class="w-4 h-4 mt-1 text-indigo-600 transition duration-150 ease-in-out form-radio"
                          />
                          <label for="weekDays" class="ml-3">
                            <span
                              class="block text-sm font-medium leading-5 text-gray-700"
                              >Ai seguenti giorni</span
                            >
                            <div class="flex">
                              <div
                                class="mt-1 mr-2 text-center border-2 rounded-full w-7 h-7 hover:bg-gray-200"
                                :class="
                                  isDaySelected(day) ? 'border-indigo-600' : ''
                                "
                                v-for="day in daysOfWeek"
                                :key="day.id"
                              >
                                <label
                                  :for="'week_day_' + day.id"
                                  @click="setscheduleType(1)"
                                >
                                  <input
                                    :value="day.id"
                                    :id="'week_day_' + day.id"
                                    type="checkbox"
                                    v-model="schedule.selectedWeekDays"
                                    class="hidden"
                                  />
                                  <div
                                    class="flex items-center justify-center h-full text-xs"
                                  >
                                    <span>{{ day.shortname }}</span>
                                  </div>
                                </label>
                              </div>
                            </div>
                          </label>
                        </div>
                        <p
                          class="mt-1 ml-8 text-xs text-red-600"
                          v-if="formErrors['schedule.selectedWeekDays']"
                        >
                          {{ formErrors["schedule.selectedWeekDays"][0] }}
                        </p>
                      </div>
                      <div class="mt-4 ">
                        <div class="flex">
                          <input
                            id="multipleDate"
                            v-model="schedule.scheduleType"
                            :value="2"
                            name="scheduleType"
                            type="radio"
                            class="w-4 h-4 mt-1 text-indigo-600 transition duration-150 ease-in-out form-radio"
                          />
                          <label for="multipleDate" class="ml-3">
                            <span
                              class="block text-sm font-medium leading-5 text-gray-700"
                              >Alle seguenti date
                            </span>
                            <div>
                              <date-picker
                                format="DD/MM/YYYY"
                                class="mt-1"
                                v-model="schedule.selectedDates"
                                :multiple="true"
                                valueType="format"
                                @open="setscheduleType(2)"
                              ></date-picker>
                            </div>
                          </label>
                        </div>
                        <p
                          class="mt-1 ml-8 text-xs text-red-600"
                          v-if="formErrors['schedule.selectedDates']"
                        >
                          {{ formErrors["schedule.selectedDates"][0] }}
                        </p>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div
                  class="col-span-6 lg:col-span-2"
                  v-show="
                    this.isEnable &&
                      (!this.isEnableMenuHotel ||
                        (this.isEnableMenuHotel && this.isRoomService))
                  "
                >
                  <div>
                    <legend
                      class="text-base font-medium leading-6 text-gray-900"
                    >
                      Scegli la fascia oraria di visibilità
                    </legend>

                    <div class="flex mt-4">
                      <input
                        class="block w-20 form-input sm:text-sm sm:leading-5"
                        v-model="schedule.startTime"
                        type="number"
                        min="0"
                        max="24"
                      />
                      <div
                        class="flex items-center justify-center w-5 text-center"
                      >
                        -
                      </div>
                      <input
                        class="block w-20 form-input sm:text-sm sm:leading-5"
                        v-model="schedule.endTime"
                        type="number"
                        min="0"
                        max="24"
                      />
                    </div>
                    <p
                      class="mt-1 text-xs text-red-600"
                      v-if="formErrors['schedule.endTime']"
                    >
                      {{ formErrors["schedule.endTime"][0] }}
                    </p>
                    <p
                      class="mt-1 text-xs text-red-600"
                      v-if="formErrors['schedule.startTime']"
                    >
                      {{ formErrors["schedule.startTime"][0] }}
                    </p>
                  </div>
                </div>

                <div class="col-span-6">
                  <label
                    class="block mt-4 text-sm font-medium leading-5 text-gray-700"
                    >Icona</label
                  >
                  <div class="relative mt-1 rounded-md shadow-sm">
                    <div
                      class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-5 h-5 text-gray-400"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          class="heroicon-ui"
                          d="M16.32 14.9l5.39 5.4a1 1 0 0 1-1.42 1.4l-5.38-5.38a8 8 0 1 1 1.41-1.41zM10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z"
                        />
                      </svg>
                    </div>
                    <input
                      v-model="serchicon"
                      class="block w-full pl-10 form-input sm:text-sm sm:leading-5"
                      placeholder="Cerca icona"
                    />
                  </div>
                  <div
                    class="flex flex-wrap h-64 mt-2 overflow-y-auto border border-gray-200 rounded-md"
                  >
                    <div
                      v-for="icon in filterIcons"
                      :key="icon.id"
                      class="mx-1.5 "
                    >
                      <label :for="'icon_' + icon.id" class="">
                        <input
                          :id="'icon_' + icon.id"
                          v-model="iconSelected"
                          type="radio"
                          :value="icon.id"
                          class="hidden"
                        />
                        <div
                          class="relative flex items-center w-20 h-20 rounded-full cursor-pointer"
                          :class="[
                            iconSelected === icon.id
                              ? 'border-2 shadow-sm bg-gray-100'
                              : '',
                            locationColor != null
                              ? 'border-' + locationColor.primary
                              : 'border-black',
                          ]"
                        >
                          <img
                            :for="'icon_' + icon.id"
                            v-lazy="icon.url"
                            class="block w-12 h-12 mx-auto"
                          />
                          <div
                            class="absolute inset-0 block w-10 h-10 mx-auto top-3"
                          ></div>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="sticky px-4 py-3 text-right rounded-b-lg shadow bg-opacity-90 -inset-6 bg-gray-50 sm:px-6"
            >
              <span class="inline-flex rounded-md shadow-sm">
                <button
                  type="submit"
                  class="inline-flex justify-center px-4 py-2 text-sm font-medium leading-5 text-white transition duration-150 ease-in-out bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700"
                >
                  <template v-if="action == 'update'">
                    Salva
                  </template>

                  <template v-if="action == 'create'">
                    Crea
                  </template>
                </button>
              </span>
            </div>
          </div>
        </form>
      </div>
    </div>
    <modal
      v-show="modal.show"
      :event="modal.event"
      :icon="modal.icon"
      :buttonText="modal.buttonText"
      :buttonClass="modal.buttonClass"
      :eventclose="modal.eventclose"
      :title="modal.title"
      :description="modal.description"
    ></modal>
  </div>
</template>

<script>
import MenuService from "../apis/MenuService";
import IconService from "../apis/IconService";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/it";
import Modal from "../components/Modal";

export default {
  props: {
    id: Number,
    idmenu: Number,
  },
  components: {
    DatePicker,
    Modal,
  },
  data() {
    return {
      icons: [],
      iconSelected: null,
      locationColor: {},
      tl: {},
      fields: ["name", "description"],
      form: {},
      formErrors: {},
      isEnable: true,
      isEnableMenuHotel: false,
      isRoomService: false,
      isStandardMenu: false,
      isEnableHidePrice: false,
      isEnableMenuFixedPrice: false,
      action: this.$route.meta.action,
      hotelOrdersSettings: [],
      menuTypeId: null,
      schedule: {
        scheduleType: 0,
        selectedWeekDays: [],
        selectedDates: [],
        startTime: 0,
        endTime: 24,
      },
      daysOfWeek: [
        {
          id: 1,
          name: "Lunedì",
          shortname: "L",
        },
        {
          id: 2,
          name: "Martedì",
          shortname: "M",
        },
        {
          id: 3,
          name: "Mercoledì",
          shortname: "M",
        },
        {
          id: 4,
          name: "Giovedì",
          shortname: "G",
        },
        {
          id: 5,
          name: "Venerdì",
          shortname: "V",
        },
        {
          id: 6,
          name: "Sabato",
          shortname: "S",
        },
        {
          id: 0,
          name: "Domenica",
          shortname: "D",
        },
      ],
      modal: {
        type: "",
        show: false,
        title: "",
        description: "",
        event: "",
        eventclose: "",
        icon: "",
        buttonText: "",
        buttonClass: "",
      },
      serchicon: "",
      reservationTypes: [
        {
          label: "giorno precedente",
          value: 0,
        },
        {
          label: "giorno stesso",
          value: 1,
        },
      ],
    };
  },
  computed: {
    filterIcons: function() {
      return this.icons.filter((x) => x.keywords.includes(this.serchicon));
    },

    alertMenuType() {
      let option = this.hotelOrdersSettings.find(
        (x) => x.id === this.menuTypeId
      );
      let reservationType = this.reservationTypes.find(
        (x) => x.value == option.settings.reservationType
      );
      if (option && reservationType) {
        return `${option.name} prenotabile dalle ore ${option.settings.startTime} alle ore ${option.settings.endTime} del ${reservationType.label}.`;
      } else {
        return "n/a errore";
      }
    },
  },
  mounted() {
    if (this.action == "create") {
      MenuService.createMenuNew(this.id).then((response) => {
        this.createDynamicReactive(response.data.data);
      });
    }

    if (this.action == "update") {
      MenuService.getMenu(this.id, this.idmenu).then((response) => {
        this.createDynamicReactive(response.data.data);
        this.schedule = { ...this.schedule, ...response.data.data.schedule };
        this.isEnable = response.data.data.enable;
        this.isEnableMenuHotel = response.data.data.isEnableMenuHotel;
        this.isRoomService = response.data.data.isRoomService;
        this.isEnableHidePrice = response.data.data.isEnableHidePrice;
        this.iconSelected = response.data.data.category_icon_id;
      });

      this.$root.$on("clickDeleteMenu" + this.idmenu, () => {
        this.deleteMenu();
      });

      this.$root.$on("clickCloseModalMenu" + this.idmenu, () => {
        this.modal.show = false;
      });
    }

    IconService.getIcons().then((response) => {
      this.icons = response.data.data;
    });
  },
  created() {},
  methods: {
    setRoomService: function() {
      this.isRoomService = true;
      this.isEnableMenuHotel = true;
      this.isStandardMenu = false;
      this.menuTypeId = null;
    },
    setMenuType: function() {
      this.isRoomService = false;
      this.isEnableMenuHotel = true;
      this.isStandardMenu = false;
    },
    setStandardMenu: function() {
      this.isRoomService = false;
      this.isEnableMenuHotel = false;
      this.isStandardMenu = true;
      this.menuTypeId = null;
    },
    deleteModal: function() {
      this.modal.event = "clickDeleteMenu" + this.idmenu;
      this.modal.eventclose = "clickCloseModalMenu" + this.idmenu;
      this.modal.title = "Sei sicuro?";
      this.modal.description =
        "Proseguendo cancellerai definitivamente il menu '" +
        this.form.name +
        "'";
      this.modal.icon = "alert";
      this.modal.buttonText = "Elimina";
      this.modal.buttonClass =
        "bg-red-600 hover:bg-red-500  focus:border-red-700 focus:shadow-outline-red";
      this.modal.show = true;
    },
    deleteMenu: function() {
      this.$store.dispatch("updateSpinner", true);
      this.modal.show = false;
      MenuService.deleteMenu(this.id, this.idmenu)
        .then(() => {
          this.$store.dispatch("updateSpinner", false);
          this.$router.push({ name: "Menus" });
          this.$store.dispatch("addNotification", {
            id: Math.floor(Math.random() * 100000),
            title: "Menu eliminata",
            description: "Il Menu è stato eliminato con successo",
          });
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.formErrors = error.response.data.errors;
          }
        });
    },
    toogle() {
      this.isEnable = !this.isEnable;
    },
    toogleHotel() {
      this.isEnableMenuHotel = !this.isEnableMenuHotel;
      if (this.isEnableMenuHotel) {
        this.isEnableHidePrice = true;
      } else {
        this.isEnableHidePrice = false;
      }
    },
    toogleFixedPrice() {
      this.isEnableMenuFixedPrice = !this.isEnableMenuFixedPrice;
    },
    toogleHidePrice() {
      this.isEnableHidePrice = !this.isEnableHidePrice;
    },
    setscheduleType(id) {
      if (id != 1) {
        this.schedule.selectedWeekDays = [];
      }

      if (id != 2) {
        this.schedule.selectedDates = [];
      }

      this.schedule.scheduleType = id;
    },
    isDaySelected(day) {
      if (
        this.schedule.selectedWeekDays == undefined ||
        this.schedule.selectedWeekDays.length == 0
      )
        return false;

      return (
        this.schedule.selectedWeekDays.filter(function(value) {
          return value === day.id;
        }).length > 0
      );
    },
    createDynamicReactive(data) {
      for (let i = 0; i < this.fields.length; i++) {
        let obj = {};
        let objErrors = {};
        for (let j = 0; j < data.checked_languages.length; j++) {
          let code = data.checked_languages[j].code;
          obj[code] = this.getTraslation(
            data.translations,
            code,
            this.fields[i]
          );
          objErrors[code] = null;
        }
        this.$set(this.tl, this.fields[i] + "Translation", obj);
        this.$set(this.tl, this.fields[i] + "TranslationErrors", objErrors);
      }
      this.form = data;
      this.checkedAllergies = data.checked_allergies || [];
      this.checkedAttributes = data.checked_attributes || [];
      this.hotelOrdersSettings = data.hotel_orders_settings || [];
      this.menuTypeId = data.menu_type_id || null;
    },

    // eslint-disable-next-line no-unused-vars
    getTraslation: function(list, code, propertyName) {
      if (list === undefined) {
        return "";
      }
      let result = list.filter((x) => x.locale == code);
      if (result.length > 0) {
        return result[0][propertyName];
      }
      return "";
    },
    showValidationErrors: function(list) {
      let keys = Object.keys(list);
      for (let i = 0; i < keys.length; i++) {
        //Errori multilingua conengono il punto
        if (keys[i].includes(".")) {
          for (let j = 0; j < this.form.checked_languages.length; j++) {
            let code = this.form.checked_languages[j].code;
            for (let k = 0; k < this.fields.length; k++) {
              if (keys[i] == this.fields[k] + "Translation." + code) {
                this.tl[this.fields[k] + "TranslationErrors"][code] =
                  list[keys[i]][0];
              }
            }
          }
        }
      }
      this.formErrors = list;
    },
    removeValidationErrors: function() {
      this.formErrors = {};
      for (let j = 0; j < this.form.checked_languages.length; j++) {
        let code = this.form.checked_languages[j].code;
        for (let k = 0; k < this.fields.length; k++) {
          this.tl[this.fields[k] + "TranslationErrors"][code] = undefined;
        }
      }
    },
    prepareData: function() {
      this.tl.schedule = this.schedule;
      this.tl.enable = this.isEnable;
      this.tl.category_icon_id = this.iconSelected;
      this.tl.isEnableMenuHotel = this.isEnableMenuHotel;
      this.tl.isEnableHidePrice = this.isEnableHidePrice;
      this.tl.menuTypeId = this.menuTypeId;
      this.tl.isRoomService = this.isRoomService;
    },
    onSubmit: function() {
      this.removeValidationErrors();
      if (this.action == "create") {
        this.$store.dispatch("updateSpinner", true);
        this.prepareData();
        MenuService.createMenu(this.id, this.tl)
          .then((response) => {
            this.$store.dispatch("updateSpinner", false);
            this.$router.push({
              name: "MenuCompose",
              params: { id: this.id, idmenu: response.data.id },
            });
            this.$store.dispatch("addNotification", {
              id: Math.floor(Math.random() * 100000),
              title: "Menu creato",
              description: "",
            });
          })
          .catch((error) => {
            if (error.response.status === 422) {
              this.showValidationErrors(error.response.data.errors);
              this.$store.dispatch("addNotification", {
                id: Math.floor(Math.random() * 100000),
                title: "Correggi gli errori",
                description: "",
                succes: false,
              });
            }

            if (error.response.status === 403) {
              const responseObj = JSON.parse(error.response.data.message);
              if (
                responseObj.upgrade_plan != undefined &&
                responseObj.upgrade_plan
              ) {
                this.$root.$on("clickUpgradeMenu", () => {
                  window.open(process.env.VUE_APP_BILLING_URL);
                });

                this.$root.$on("clickCloseUpgradeModalMenu", () => {
                  this.modal.show = false;
                });

                this.modal.event = "clickUpgradeMenu";
                this.modal.eventclose = "clickCloseUpgradeModalMenu";

                this.modal.description = responseObj.description || "";
                this.modal.title = responseObj.title || "";
                this.modal.icon = "diamond";
                this.modal.buttonText = "Scopri tariffe";
                this.modal.buttonClass =
                  "bg-green-400 hover:bg-green-500  focus:border-green-400 focus:shadow-outline-green";
                this.modal.show = true;
              }
            }
            this.$store.dispatch("updateSpinner", false);
          });
      }

      if (this.action == "update") {
        this.$store.dispatch("updateSpinner", true);
        this.prepareData();
        MenuService.updateMenu(this.id, this.idmenu, this.tl)
          .then(() => {
            this.$store.dispatch("updateSpinner", false);
            this.$store.dispatch("addNotification", {
              id: Math.floor(Math.random() * 100000),
              title: "Dati aggiornati",
              description: "",
            });
          })
          .catch((error) => {
            if (error.response.status === 422) {
              this.showValidationErrors(error.response.data.errors);
            }
            this.$store.dispatch("updateSpinner", false);
          });
      }
    },
    deleteClick: function() {
      /*
        CategoryService.deleteCategory(this.id, this.idcategory)
          .then(() => {
            this.$router.push({ name: "Categories", params: { id: this.id} });
        })
        .catch(error => {
            this.formErrors = error.response.data.errors;
          
        });
        */
    },
    copyText: function(text) {
      for (let i = 0; i < this.form.checked_languages.length; i++) {
        let code = this.form.checked_languages[i].code;
        if (
          this.tl.nameTranslation[code] === null ||
          this.tl.nameTranslation[code] === ""
        ) {
          this.tl.nameTranslation[code] = text;
        }
      }
    },
    copyDescrText: function(text) {
      for (let i = 0; i < this.form.checked_languages.length; i++) {
        let code = this.form.checked_languages[i].code;
        if (
          this.tl.descriptionTranslation[code] === null ||
          this.tl.descriptionTranslation[code] === ""
        ) {
          this.tl.descriptionTranslation[code] = text;
        }
      }
    },
  },
};
</script>
